import { handleOpenChat } from "utils/analytics";

export default function Wpp() {
  return (
    <div className="absolute bottom-32 z-10 w-full">
      <div className="flex flex-col items-center">
        <p className="text-white text-3xl font-bold md:leading-snug md:text-6xl text-center">
          AGENDE AGORA MESMO<br/> SEU PASSEIO PRIVATIVO
        </p>
        <button type="button" className="mt-10 bg-green-600 rounded-lg flex items-center px-5 py-3" onClick={handleOpenChat}>
          <p className=" text-white text-xl md:text-3xl">
            FALE CONOSCO
          </p>
          <img src="/wpp.svg" className="h-10 pl-6" alt="Fale conosco" />
        </button>
      </div>
    </div>
  )
}